import React from 'react'
import Modal from 'modal-enhanced-react-native-web'

export default ({ visible, onClose, backDropAction, children, ...rest }) => (
  <Modal
    backdropOpacity={0.5}
    backdropColor="rgba(0, 0, 0, 0.6)"
    isVisible={visible}
    onBackdropPress={() => backDropAction && onClose()}
    onBackButtonPress={onClose}
    {...rest}
  >
    {children}
  </Modal>
)
